module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    on: {
      "mousemove": function($event) {
        return _vm.stopInterval()
      },
      "click": function($event) {
        return _vm.stopInterval()
      }
    }
  }, [(_vm.isMobile) ? _c('v-btn', {
    staticClass: "elevation-0",
    staticStyle: {
      "top": "70px",
      "width": "56px",
      "height": "56px",
      "right": "0px",
      "border-radius": "6px",
      "border-bottom-right-radius": "0",
      "border-top-right-radius": "0",
      "background-color": "#002c46d4!important"
    },
    attrs: {
      "color": "grey",
      "dark": "",
      "fab": "",
      "fixed": "",
      "top": "",
      "right": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "size": "32"
    }
  }, [_vm._v("list")])], 1) : _vm._e(), _vm._v(" "), (_vm.isMobile) ? _c('v-navigation-drawer', {
    staticStyle: {
      "background": "#002c46d4",
      "position": "fixed",
      "top": "0px",
      "left": "0px"
    },
    attrs: {
      "dark": "",
      "temporary": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.image,
      "height": "100%"
    }
  }, [_c('v-layout', {
    staticClass: "fill-height",
    attrs: {
      "tag": "v-list",
      "column": ""
    }
  }, _vm._l((_vm.kiosItems), function(item, index) {
    return _c('v-list-tile', {
      key: index,
      staticClass: "v-list-item",
      class: _vm.active === index ? 'active_drawer' : '',
      attrs: {
        "avatar": ""
      },
      on: {
        "click": function($event) {
          return _vm.goPage(item.route, index)
        }
      }
    }, [_c('v-list-tile-action', {
      staticClass: "mx-2"
    }, [_c('v-icon', {
      attrs: {
        "size": "26"
      }
    }, [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-title', {
      staticStyle: {
        "font-size": "16px"
      },
      domProps: {
        "textContent": _vm._s(item.text)
      }
    })], 1)
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isMobile) ? _c('v-content', [_c('router-view')], 1) : _c('v-content', [_c('v-card', {
    staticStyle: {
      "font-family": "'Times New Roman', Times, serif",
      "height": "130px"
    },
    attrs: {
      "flat": "",
      "color": "#0f66dd"
    }
  }, [_c('v-flex', {
    staticClass: "header_dhxh text-xs-center pt-1",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "logo d-inline-block"
  }, [_c('div', {
    staticClass: "d-inline-block px-3 pt-2",
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "left": "0"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px"
    },
    attrs: {
      "src": '/documents/' + _vm.groupId + '/0/logo.png'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center mt-3",
    staticStyle: {
      "font-size": "16px",
      "color": "#e5e0e0"
    }
  }, [_vm._v("BỘ NGOẠI GIAO")])]), _vm._v(" "), _c('div', {
    staticClass: "d-inline-block px-2 pt-2",
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "right": "0"
    }
  }, [_c('img', {
    staticClass: "img-slogan mb-3",
    staticStyle: {
      "width": "70px"
    },
    attrs: {
      "src": '/documents/' + _vm.groupId + '/0/ct.png'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center",
    staticStyle: {
      "font-size": "14px",
      "color": "#e5e0e0"
    }
  }, [_vm._v("CHUNG TAY CẢI CÁCH")]), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center mt-1",
    staticStyle: {
      "font-size": "14px",
      "color": "#e5e0e0"
    }
  }, [_vm._v("THỦ TỤC HÀNH CHÍNH")])]), _vm._v(" "), _c('div', {
    staticClass: "mb-1 mt-2",
    staticStyle: {
      "font-size": "26px",
      "color": "#e5e0e0"
    }
  }, [_vm._v("BỘ PHẬN TIẾP NHẬN HỒ SƠ VÀ TRẢ KẾT QUẢ")]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "line-height": "5px"
    }
  }, [_c('div', {
    staticClass: "underline-white",
    staticStyle: {
      "width": "350px",
      "height": "2px"
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center pt-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "32px",
      "color": "#f7d900",
      "height": "50px"
    }
  }, [_vm._v("\n              TRA CỨU THÔNG TIN\n            ")])])], 1)])], 1), _vm._v(" "), _c('section', {
    class: _vm.isKios && _vm.wrapStyle ? 'kios-content-wrapper' : '',
    on: {
      "mousemove": function($event) {
        return _vm.stopInterval()
      },
      "click": function($event) {
        return _vm.stopInterval()
      }
    }
  }, [_c('div', {
    class: _vm.isKios ? 'tab-item' : ''
  }, [(!_vm.fullScreen) ? _c('div', {
    staticClass: "left",
    class: _vm.fullScreen ? 'smallScreen' : ''
  }, [_c('a', {
    staticClass: "active",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.goPage('ketquahoso')
      }
    }
  }, [_c('p', {
    staticClass: "icon px-2"
  }, [_c('img', {
    attrs: {
      "src": "/o/opencps-store/js/kios/img/icons-document.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ml-2 my-0"
  }, [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("Hồ sơ đã có kết quả")])])]), _vm._v(" "), _c('a', {
    staticClass: "active",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.goPage('tiepnhanhoso')
      }
    }
  }, [_c('p', {
    staticClass: "icon px-2"
  }, [_c('img', {
    attrs: {
      "src": "/o/opencps-store/js/kios/img/icons8-open-file-50.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ml-2 my-0"
  }, [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("Hồ sơ đã tiếp nhận")])])]), _vm._v(" "), _c('a', {
    staticClass: "active",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.goPage('tracuuhoso')
      }
    }
  }, [_c('p', {
    staticClass: "icon px-2"
  }, [_c('img', {
    attrs: {
      "src": "/o/opencps-store/js/kios/img/icons-search-50.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ml-2 my-0"
  }, [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("Tra cứu hồ sơ")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.goPage('tracuuthutuc')
      }
    }
  }, [_c('p', {
    staticClass: "icon px-2"
  }, [_c('img', {
    attrs: {
      "src": "/o/opencps-store/js/kios/img/icon-search-dc-50.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ml-2 my-0"
  }, [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("Tra cứu thủ tục")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.goPage('danhgia')
      }
    }
  }, [_c('p', {
    staticClass: "icon pl-1 pr-2"
  }, [_c('img', {
    attrs: {
      "src": "/o/opencps-store/js/kios/img/icon-evaluation.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ml-2 my-0"
  }, [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("Đánh giá cán bộ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "right",
    class: _vm.fullScreen ? 'fullScreen' : ''
  }, [_c('div', {
    staticClass: "right-content"
  }, [_c('router-view')], 1)])])])], 1), _vm._v(" "), (_vm.enableToTop) ? _c('v-btn', {
    staticStyle: {
      "width": "56px",
      "height": "56px"
    },
    attrs: {
      "fab": "",
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "color": "#002c46d4"
    },
    on: {
      "click": function($event) {
        return _vm.$vuetify.goTo(0)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "size": "40"
    }
  }, [_vm._v("keyboard_arrow_up")])], 1) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f79fe98e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f79fe98e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 542
// module chunks = 1